// Copyright (C) 2019-2022 Intel Corporation
// Copyright (C) 2022-2023 CVAT.ai Corporation
//
// SPDX-License-Identifier: MIT

import './styles.scss';
import React from 'react';
import { useLocation } from 'react-router';
import { Row, Col } from 'antd/lib/grid';
import Text from 'antd/lib/typography/Text';

import CreateReferenceContent, { CreateReferenceData } from './create-reference-content';

interface Props {
    onCreate: (data: CreateReferenceData, onProgress?: (status: string) => void) => Promise<any>;
}

export default function CreateReferencePage(props: Props): JSX.Element {
    const { onCreate } = props;

    const location = useLocation();

    let projectId = null;
    let taskId = null;
    const params = new URLSearchParams(location.search);
    if (params.get('projectId')?.match(/^[1-9]+[0-9]*$/)) {
        projectId = +(params.get('projectId') as string);
    }
    if (params.get('taskId')?.match(/^[1-9]+[0-9]*$/)) {
        taskId = +(params.get('taskId') as string);
    }
    const many = params.get('many') === 'true';
    const handleCreate: typeof onCreate = (...onCreateParams) => onCreate(...onCreateParams);

    return (
        <Row justify='center' align='top' className='cvat-create-work-form-wrapper'>
            <Col md={20} lg={16} xl={14} xxl={9}>
                <Text className='cvat-title'>Create a new reference</Text>
                <CreateReferenceContent projectId={projectId} taskId={taskId} onCreate={handleCreate} many={many} />
            </Col>
        </Row>
    );
}
